import { EVENT_DETAILS_FIELD, EVENT_SOURCE_FIELD, EVENT_TARGET_FIELD } from 'schemas/constants';
import { DEFAULT_FIELDS } from 'schemas/default-fields';
import { EVENT_DETAILS_FIELDS_BY_CATEGORY } from 'schemas/sentinel-one/event-details-fields-by-category';
import { DATASOURCE, FIELD_TYPE, Schema } from 'schemas/types';
import { textFields, timestampFields } from './fields';

export const schema: Schema = {
  dataSource: DATASOURCE.GENERIC_XDR,
  dataSourceId: 'Generic',
  dataSourceVendor: 'Generic',
  dataSourceLabel: 'Generic XDR',
  fields: {
    ...DEFAULT_FIELDS,
    [EVENT_SOURCE_FIELD]: {
      label: 'Event Source',
      type: FIELD_TYPE.EVENT_SOURCE,
      notSearchable: true,
      relatedFields: [
        'endpoint.name',
        'src.endpoint.ip.address',
        'src.process.uid',
        'event.login.userName',
        'src.ip.address',
      ],
      width: 540, // (160 + 20) x 3
    },
    [EVENT_TARGET_FIELD]: {
      label: 'Event Target',
      type: FIELD_TYPE.EVENT_TARGET,
      notSearchable: true,
      relatedFields: [
        'tgt.file.path',
        'task.name',
        'dst.ip.address',
        'tgt.process.uid',
        'url.address',
        'event.dns.request',
        'registry.keyPath',
        'module.path',
      ],
      width: 540, // (160 + 20) x 3
    },
    [EVENT_DETAILS_FIELD]: {
      label: 'Event Details',
      type: FIELD_TYPE.EVENT_DETAILS,
      description: 'Event additional details',
      notSearchable: true,
      width: 900, // (160 + 20) x 5,
      relatedFieldsMap: EVENT_DETAILS_FIELDS_BY_CATEGORY,
    },
    'endpoint.name': {
      label: 'Endpoint Name',
      type: FIELD_TYPE.DEVICE,
    },
    'event.externalLink': {
      label: 'Event external ID',
      type: FIELD_TYPE.LINK,
    },
    'src.process.name': {
      type: FIELD_TYPE.TEXT,
      label: 'Source Process Name',
      description: 'Name of source process',
    },
    'src.process.uid': {
      label: 'Source Process UID',
      type: FIELD_TYPE.PROCESS,
      description: 'Unique ID of source process',
      relatedFields: [
        'agent.uuid',
        'event.time',
        'mgmt.url',
        'src.process.name',
        'src.process.startTime',
        'src.process.storyline.id',
      ],
      width: 180,
    },
    'src.process.user': {
      type: FIELD_TYPE.USER,
      label: 'Source Process User',
      description: 'Username under which source process ran',
    },
    'src.process.parent.name': {
      type: FIELD_TYPE.TEXT,
      label: 'OS Source Process Parent Process',
      description: 'Name of the process that created the OS source process (as attributed by the OS)',
    },
    'src.process.parent.uid': {
      type: FIELD_TYPE.PROCESS,
      label: 'Source Process Parent UID',
      description: 'Unique ID of process that created this process',
      relatedFields: [
        'agent.uuid',
        'event.time',
        'mgmt.url',
        'src.process.parent.name',
        'src.process.startTime',
        'src.process.parent.storyline.id',
      ],
      width: 180,
    },
    'src.process.parent.user': {
      type: FIELD_TYPE.USER,
      label: 'Source Process Parent User',
      description: 'Username under which the process that created this process ran',
    },
    'tgt.process.name': {
      type: FIELD_TYPE.TEXT,
      label: 'Target Process Name',
      description: 'Name of target process',
    },
    'tgt.process.uid': {
      type: FIELD_TYPE.PROCESS,
      label: 'Target Process UID',
      relatedFields: [
        'agent.uuid',
        'event.time',
        'mgmt.url',
        'tgt.process.name',
        'tgt.process.startTime',
        'tgt.process.storyline.id',
      ],
      width: 180,
    },
    'tgt.process.user': {
      type: FIELD_TYPE.USER,
      label: 'Source Process User',
      description: 'Username under which target process ran',
    },
    'src.ip.address': {
      type: FIELD_TYPE.IP_ADDRESS,
      label: 'Source IP',
      description: 'IP address of traffic source',
    },
    'dst.ip.address': {
      type: FIELD_TYPE.IP_ADDRESS,
      label: 'Destination IP',
      description: 'IP address of traffic destination',
    },
    'event.dns.request': {
      type: FIELD_TYPE.DNS,
      label: 'DNS Request',
      description: 'DNS name',
    },
    'url.address': {
      type: FIELD_TYPE.URL,
      label: 'URL',
    },
    'tgt.file.path': {
      type: FIELD_TYPE.FILE,
      label: 'Target File Path',
    },
    'registry.keyPath': {
      type: FIELD_TYPE.REGISTRY_KEY,
      label: 'Registry Key Path',
      description: 'Full path location of the Registry Key entry',
    },
    'task.name': {
      type: FIELD_TYPE.TASK,
      label: 'Task name',
    },
    'module.path': {
      type: FIELD_TYPE.MODULE,
      label: 'Module Path',
      description: 'Module Path',
    },
    'event.login.userName': {
      type: FIELD_TYPE.USER,
      label: 'Logins User Name',
      description: 'Logins User Name',
    },
    'src.endpoint.ip.address': {
      type: FIELD_TYPE.IP_ADDRESS,
      label: 'Source Machine IP',
      description: 'IP of the machine name performing the login attempt',
    },
    ...textFields,
    ...timestampFields,
  },
};
